import useGetNotificationReceiverUserIdData from './useGetNotificationReceiverUserIdData'

export default useGetNotificationReceiverUserIdData
